import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/dist/query'
import { mapboxApi } from '../services/mapbox'
import locator from '../slices/locator'

const store = configureStore( {
  reducer : {
    [mapboxApi.reducerPath] : mapboxApi.reducer,
    locator,
  },
  middleware : ( getDefaultMiddleware ) => getDefaultMiddleware().concat( mapboxApi.middleware ),
} )

setupListeners( store )

export default store
